import React, { useState } from "react";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import "../CSS/FloatingButtons.css";

const FloatingButtons = () => {
  const [showTooltip, setShowTooltip] = useState({
    call: false,
    whatsapp: false
  });

  const phoneNumber = "+916393244687";
  const whatsappNumber = "+916393244687";
  const whatsappMessage = "Hello! I need assistance with document services.";

  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(whatsappMessage)}`,
      "_blank"
    );
  };

  return (
    <>
      {/* Call Button - Bottom Left */}
      <div 
        className="floating-btn floating-call"
        onMouseEnter={() => setShowTooltip({ ...showTooltip, call: true })}
        onMouseLeave={() => setShowTooltip({ ...showTooltip, call: false })}
      >
        <button onClick={handleCall} className="btn-call">
          <FaPhoneAlt />
        </button>
        {showTooltip.call && (
          <div className="tooltip tooltip-call">
            <span>Call Now: {phoneNumber}</span>
          </div>
        )}
        <span className="ripple"></span>
      </div>

      {/* WhatsApp Button - Bottom Right */}
      <div 
        className="floating-btn floating-whatsapp"
        onMouseEnter={() => setShowTooltip({ ...showTooltip, whatsapp: true })}
        onMouseLeave={() => setShowTooltip({ ...showTooltip, whatsapp: false })}
      >
        <button onClick={handleWhatsApp} className="btn-whatsapp">
          <FaWhatsapp />
        </button>
        {showTooltip.whatsapp && (
          <div className="tooltip tooltip-whatsapp">
            <span>Chat on WhatsApp</span>
          </div>
        )}
        <span className="ripple"></span>
      </div>
    </>
  );
};

export default FloatingButtons;